/**
 * Site Refresh 2026: cart drawer (A7). "Added to cart" with the gold tick on the line just added,
 * only right after an add: the variant id is read from the /cart/add request, the mark is put on the
 * matching line when the theme re-renders the drawer, and cleared when the drawer closes.
 */
(() => {
	if (window.__rcdInit) return;
	window.__rcdInit = true;

	let added = null; // { id, t }
	const FRESH_MS = 20000;

	function idFromBody(body) {
		try {
			if (!body) return null;
			if (typeof FormData !== 'undefined' && body instanceof FormData) return body.get('id') || body.get('items[0][id]');
			if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.get('id');
			if (typeof body === 'string') {
				if (body.trim().charAt(0) === '{') {
					const j = JSON.parse(body);
					return j.id || (j.items && j.items[0] && j.items[0].id) || null;
				}
				return new URLSearchParams(body).get('id');
			}
		} catch (e) { /* not a body we can read */ }
		return null;
	}

	function note(id) {
		if (!id) return;
		added = { id: String(id), t: Date.now() };
		setTimeout(mark, 0);
	}

	const origFetch = window.fetch;
	if (origFetch) {
		window.fetch = function (input, init) {
			try {
				const url = typeof input === 'string' ? input : (input && input.url) || '';
				if (/\/cart\/add/.test(url)) note(idFromBody(init && init.body));
			} catch (e) { /* ignore */ }
			return origFetch.apply(this, arguments);
		};
	}

	const origSend = XMLHttpRequest.prototype.send;
	const origOpen = XMLHttpRequest.prototype.open;
	XMLHttpRequest.prototype.open = function (method, url) {
		this.__rcdUrl = url;
		return origOpen.apply(this, arguments);
	};
	XMLHttpRequest.prototype.send = function (body) {
		try { if (/\/cart\/add/.test(this.__rcdUrl || '')) note(idFromBody(body)); } catch (e) { /* ignore */ }
		return origSend.apply(this, arguments);
	};

	function drawer() { return document.getElementById('CartDrawer'); }

	function mark() {
		const d = drawer();
		if (!d || !d.classList.contains('rcd')) return;
		const fresh = added && Date.now() - added.t < FRESH_MS;
		d.querySelectorAll('.rcd-added').forEach((el) => {
			if (!fresh || el.closest('.cart-item').getAttribute('data-variant-id') !== added.id) el.remove();
		});
		if (!fresh) return;
		const item = d.querySelector('.cart-item[data-variant-id="' + added.id + '"]');
		if (!item || item.querySelector('.rcd-added')) return;
		const p = document.createElement('p');
		p.className = 'rcd-added';
		p.setAttribute('role', 'status');
		p.innerHTML = '<span class="rcd-added__tick" aria-hidden="true"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2"><path d="M5 12l5 5 9-10"/></svg></span>';
		p.appendChild(document.createTextNode(d.getAttribute('data-rcd-added') || 'Added to cart'));
		item.insertBefore(p, item.firstChild);
	}

	function watch() {
		const d = drawer();
		if (!d) return;
		// Re-renders of the drawer's content: put the mark back on the right line
		new MutationObserver(() => { if (added) mark(); }).observe(d, { childList: true, subtree: true });
		// Closing the drawer ends "right after an add"
		new MutationObserver(() => {
			if (!d.classList.contains('is-active') && added) {
				added = null;
				d.querySelectorAll('.rcd-added').forEach((el) => el.remove());
			}
		}).observe(d, { attributes: true, attributeFilter: ['class'] });
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
	else watch();
})();
